import { onBeforeUnmount, ref } from 'vue'

/**
 * Whether the window is wide (Tailwind's `lg`, 1024 px, by default): a part only a wide screen
 * shows (a 3D scene) is then not even loaded on a phone.
 */
export function useWide(minWidth = 1024) {
  const query = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(`(min-width: ${minWidth}px)`) : null
  const wide = ref(query?.matches ?? false)
  const change = (e: MediaQueryListEvent) => { wide.value = e.matches }
  query?.addEventListener('change', change)
  onBeforeUnmount(() => query?.removeEventListener('change', change))
  return wide
}
